import { Component, Input, OnInit } from '@angular/core';
import { SurveyStatistcsService } from '../survey-statistcs.service';

@Component({
  selector: 'ps-ui-epc',
  templateUrl: './epc.component.html',
  styleUrls: ['./epc.component.css'],
})
export class EpcComponent implements OnInit {
  public epcPlatform: string = '-';
  public epcEstimate: string = '-';
  public epcActual: string = '-';

  private _countryCode: string = 'US';
  private _surveyGoal?: number;
  private _incidence?: string;
  private _cpi?: string;
  private _margin?: number;

  @Input() surveyId!: number;
  @Input() showActualEpc: boolean = false;

  @Input() set countryCode(countryCode: string) {
    this._countryCode = countryCode;
    this._getPlatformEpc();
  }

  @Input() set surveyGoal(surveyGoal: number) {
    this._surveyGoal = surveyGoal;
    this._getEpcEstimate();
  }

  @Input() set incidence(incidence: string) {
    this._incidence = incidence;
    this._getEpcEstimate();
  }

  @Input() set cpi(cpi: string) {
    this._cpi = cpi;
    this._getEpcEstimate();
  }

  @Input() set margin(margin: number) {
    this._margin = margin;
    this._getEpcEstimate();
  }

  constructor(private _surveyStatistcsService: SurveyStatistcsService) {}

  ngOnInit(): void {
    this._getPlatformEpc();
    if (this.showActualEpc) {
      this._getSurveyActualEpc();
    }
  }

  private _getPlatformEpc() {
    this._surveyStatistcsService
      .getEpcPlatform(this._countryCode)
      .subscribe((response) => {
        this.epcPlatform = response.epcPlatform;
      });
  }

  private _getEpcEstimate() {
    if (!this._hasDataToCalculateEpcEstimate()) {
      return;
    }
    this._surveyStatistcsService
      .getEpcEstimate(
        this._surveyGoal!.toString(),
        this._incidence!,
        this._cpi!,
        this._margin!
      )
      .subscribe((response) => {
        this.epcEstimate = response.epcEstimate;
      });
  }

  private _getSurveyActualEpc() {
    this._surveyStatistcsService
      .getSurveyActualEpc(this.surveyId)
      .subscribe((response) => {
        this.epcActual = response.epcActual;
      });
  }

  private _hasDataToCalculateEpcEstimate() {
    return this._surveyGoal && this._incidence && this._cpi && this._margin;
  }
}
